import { N } from './fancybox-LP8kq017.js';

class ProductMedia extends HTMLElement {
  #mediaItems = [...this.querySelectorAll('.product-media-item')];
  #thumbSwiper;

  async connectedCallback() {
    await this.#initThumbSwiper();
    await this.#initSwiper();
    this.initFancybox();
  }

  async #initSwiper() {
    if (this.#mediaItems.length <= 1) return;

    try {
      const { Swiper } = await import('@services');
      const { Thumbs, Navigation } = await import('./index-DT9yq2j_.js');

      new Swiper('.swiper--media', {
        modules: [Thumbs, Navigation],
        spaceBetween: 16,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        thumbs: {
          swiper: this.#thumbSwiper,
        },
      });
    } catch (error) {
      console.error('Error initializing Swiper:', error);
    }
  }

  async #initThumbSwiper() {
    if (this.#mediaItems.length <= 1) return;

    try {
      const { Swiper } = await import('@services');

      this.#thumbSwiper = new Swiper('.swiper--thumbs', {
        spaceBetween: 8,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
      });
    } catch (error) {
      console.error('Error initializing thumb Swiper:', error);
    }
  }

  initFancybox() {
    N.bind('[data-fancybox]', {
      Carousel: {
        Panzoom: {
          touch: (panzoom, event) => event?.target.nodeName !== 'MODEL-VIEWER',
        },
      },
    });
  }
}

customElements.define('product-media', ProductMedia);
